module.exports = __webpack_public_path__ + "img/fill_1.16930bfa.svg";